import { createClient } from '@supabase/supabase-js';

// Same Supabase instance as main Work Van app
const supabaseUrl = 'https://wrgmicftdykgaygbnkqn.supabase.co';

// Anon key for authentication only
const anonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndyZ21pY2Z0ZHlrZ2F5Z2Jua3FuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjU2MDIzNTYsImV4cCI6MjA4MTE3ODM1Nn0.CpRdUWBAti0qGCLKIZCaydk4h4Nnifx6apBEwy0k4E8';

// Service role key for admin data access (bypasses RLS)
const serviceRoleKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndyZ21pY2Z0ZHlrZ2F5Z2Jua3FuIiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTc2NTYwMjM1NiwiZXhwIjoyMDgxMTc4MzU2fQ.ssiKFe5dGjiP9QAjFmVeyVrkHCFKz_AznT_85Qsvqxg';

// Auth client - uses anon key for login verification
export const supabaseAuth = createClient(supabaseUrl, anonKey);

// Data client - uses service role key for bypassing RLS on all queries
// This ensures admin can see ALL data across all companies
export const supabase = createClient(supabaseUrl, serviceRoleKey, {
  auth: {
    autoRefreshToken: false,
    persistSession: false,
    detectSessionInUrl: false
  }
});
